// extracted by mini-css-extract-plugin
export default {"deltaContainer":"StaticRangeSelector_deltaContainer__sTR0u","deltaItem":"StaticRangeSelector_deltaItem__ssfdn","deltaItem_active":"StaticRangeSelector_deltaItem_active__fdshe"};